var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 4.16675C6.22464 4.16675 5.80072 4.34234 5.48816 4.6549C5.17559 4.96746 5 5.39139 5 5.83341V14.1667C5 14.6088 5.17559 15.0327 5.48816 15.3453C5.80072 15.6578 6.22464 15.8334 6.66667 15.8334C7.10869 15.8334 7.53262 15.6578 7.84518 15.3453C8.15774 15.0327 8.33333 14.6088 8.33333 14.1667V5.83341C8.33333 5.39139 8.15774 4.96746 7.84518 4.6549C7.53262 4.34234 7.10869 4.16675 6.66667 4.16675ZM13.3333 4.16675C12.8913 4.16675 12.4674 4.34234 12.1548 4.6549C11.8423 4.96746 11.6667 5.39139 11.6667 5.83341V14.1667C11.6667 14.6088 11.8423 15.0327 12.1548 15.3453C12.4674 15.6578 12.8913 15.8334 13.3333 15.8334C13.7754 15.8334 14.1993 15.6578 14.5118 15.3453C14.8244 15.0327 15 14.6088 15 14.1667V5.83341C15 5.39139 14.8244 4.96746 14.5118 4.6549C14.1993 4.34234 13.7754 4.16675 13.3333 4.16675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.015b2f9b600c7eab3e30b6dcaff69c0f.svg";
export { ForwardRef as ReactComponent };